import { createFactory, createClass, DOM } from "../../js/libs/react/react-polyfill";
import FormPanel from "../form/FormPanel";
import GameClient from "../GameClient";

var enableLog = false;

/**
 * PlayerWindow is a part of game interface consisting of history and action panel
 * props:
 *   form
 */
export default createFactory(createClass({

  displayName: "PlayerWindow",
  
  // this function is called when a move option is picked
  handleAction: function(v) {
    if (enableLog) {
      console.log("Handler parameter: ");
      console.log(v);
    }
    if(this.props.onMove) this.props.onMove();
    GameClient.makeMove("Player", v);
  },
  
  emptyForm: function() {
    return DOM.div({ className: "player-window" },
      DOM.div({ className: "empty-form-message" },
        '' //config.ui.EmptyFormMsg.text
      )
    );
  },
  
  render: function() {
    if(this.props.form.type === "EmptyForm") return this.emptyForm();
		var form = this.props.form;
    return DOM.div({ className: "player-window" },
      DOM.div({ className: "form-top-panel" },
        FormPanel({
          form: form,
          handler: this.handleAction
        })
      )
    );
  }
  
}));
